export default {
  // Header
  nav: {
    inicio: 'Hasiera',
    aurion: 'AURION',
    sectores: 'Sektoreak',
    metodo: 'Metodoa',
    porQueAurion: 'Zergatik AURION',
    noticias: 'Berriak eta merkatua',
    estudioGratuito: 'Doako azterketa',
    faqs: 'FAQak',
    contacto: 'Kontaktua'
  },

  // Hero
  hero: {
    titulo: '360º-ko industria-soluzio energetikoak',
    subtitulo: 'Ingeniaritza, legala eta finantzaketa integratuak kostuak eta karbono-aztarna murrizteko teknologia berriztagarri eta jasangarriekin.',
    destacado1: 'Zure instalazio energetikoak finantzatzen, diseinatzen, legalizatzen eta operatzen ditugu.',
    destacado2: 'Kontsumitutako energia erabilgarriagatik soilik ordaintzen duzu, hasieratik finkatutako prezio finkoan',
    beneficio1: 'Berehalako aurrezkia energia-kostuetan eta prezioen egonkortasuna epe luzera',
    beneficio2: 'Industria-prozesuen deskarbonizazioa CAPEX gabe',
    beneficio3: 'Proiektuaren kudeaketa integrala: ingeniaritza, baimenak, obra, laguntzak eta diru-laguntzak',
    ctaEstudio: 'Doako azterketa eskatu',
    ctaCasos: 'Kasuak eta erreferentziak ikusi'
  },

  // About Aurion
  about: {
    titulo: 'AURION-i buruz',
    subtitulo: 'Zure bazkide estrategikoa industria-trantsizio energetikoan',
    descripcion: 'AURION industria eta nekazaritza-elikadura sektorerako soluzio energetiko integraletan espezializatutako enpresa da. Abangoardiako ingeniaritza, esperientzia legala eta finantza-gaitasuna konbinatzen ditugu gako eskuko proiektuak eskaintzeko.',
    experiencia: 'Urte esperientzia',
    proyectos: 'Proiektu gauzatuak',
    mwInstalados: 'MW instalatutakoak',
    satisfaccion: 'Bezeroaren gogobetetasuna'
  },

  // Solutions
  solutions: {
    titulo: '360º-ko soluzio energetikoak industriarako',
    subtitulo: 'Solaskide bakarra zure industria-proiektu energetiko osorako',
    ingenieria: {
      titulo: 'Ingeniaritza eta industria-teknologia',
      descripcion: 'Fotovoltaikoa industria-kontsumo handietarako, biomasa termikoa lurrun eta prozesu-berorako, hibridazio energetiko sistemak, bateria adimendunak gailurren kudeaketarako, digitalizazioa eta instalazioen kontrol aurreratua.',
      feature1: 'Industria-prozesuetara egokitutako diseinu teknikoa',
      feature2: 'Dauden sistemekin integrazioa',
      feature3: 'Errendimendu energetikoaren optimizazioa',
      feature4: 'Denbora errealeko monitorizazioa eta kontrola'
    },
    compliance: {
      titulo: 'Industria-compliance eta legala',
      descripcion: 'Industria-baimen eta lizentzien kudeaketa integrala, due diligence erregulatzaile osoa, kontratazio energetiko korporatiboa eta PPAak, ingurumen eta ESG araudiarekin lerrokatzea.',
      feature1: 'Industria-baimenen tramitazioa',
      feature2: 'Auditoritza erregulatzaile osoa',
      feature3: 'Energia-kontratuen negoziaketa',
      feature4: 'Arau-betetze bermatua'
    },
    financiacion: {
      titulo: 'Industria-finantzaketa eta laguntzak',
      descripcion: 'CAPEX/OPEX/PPA egitura finantzario korporatiboak proiektu handietara egokituak, egitura finantzario optimizatua, Next Generation diru-laguntzen eta zerga-kenketen kudeaketa, inbertitzaileentzako ESG txostenak.',
      feature1: 'Bideragarritasun ekonomikoaren analisia',
      feature2: 'Zerga eta finantzaketa optimizazioa',
      feature3: 'Europar laguntzen kudeaketa',
      feature4: 'ESG txosten korporatiboak'
    },
    mensaje: 'Zure instalazio energetikoak finantzatzen, diseinatzen, legalizatzen eta operatzen ditugu.',
    mensajeDestacado: 'Zuk kontsumitutako energia erabilgarriagatik soilik ordaintzen duzu, hasieratik hitzartutako prezio finkoan'
  },

  // Sectors
  sectors: {
    titulo: 'Jarduera-sektoreak',
    subtitulo: 'Industria-sektore bakoitzaren behar espezifikoetara egokitutako soluzioak',
    manufacturera: {
      titulo: 'Manufaktura-industria',
      descripcion: 'Fabrikazio-prozesuak, soldadura, tratamendu termikoak, aire konprimitua, nabe-klimatizazioa'
    },
    agroalimentaria: {
      titulo: 'Nekazaritza-elikadura',
      descripcion: 'Elikagaien prozesatzea, kontserbazioa, lehorketa, hozketa, CIP garbiketa-sistemak'
    },
    quimica: {
      titulo: 'Kimikoa',
      descripcion: 'Erreakzio-prozesuak, destilazioa, lehorketa, tenperatura-kontrola, uren tratamendua'
    },
    bebidas: {
      titulo: 'Edari-industria',
      descripcion: 'Hozte industriala, pasteurizazioa, CIP/SIP, botilaketan eta ontziratzea'
    },
    caucho: {
      titulo: 'Kautxu-industria',
      descripcion: 'Bulkanizazioa, molde-beroketa, aire konprimitua, sendotze-sistemak'
    },
    textil: {
      titulo: 'Testu-industria',
      descripcion: 'Tindatzeko, lehortze eta akaberetarako prozesu termikoak, lurrun industriala, nabe-klimatizazioa'
    }
  },

  // Method
  method: {
    titulo: 'Gure Metodoa',
    subtitulo: 'Zure proiektu energetikoaren arrakasta bermatzeko prozesu egituratua',
    paso1: {
      titulo: 'Analisia',
      descripcion: 'Zure kontsumo eta energia-beharren azterketa zehatza'
    },
    paso2: {
      titulo: 'Diseinua',
      descripcion: 'Zure instalazioari egokitutako soluzio optimoaren ingeniaritza'
    },
    paso3: {
      titulo: 'Finantzaketa',
      descripcion: 'Egitura finantzarioa eta laguntzen kudeaketa'
    },
    paso4: {
      titulo: 'Exekuzioa',
      descripcion: 'Gako eskuko instalazioa kalitate-bermarekin'
    },
    paso5: {
      titulo: 'Operazioa',
      descripcion: 'Sistemaren mantentze-lanak eta etengabeko optimizazioa'
    }
  },

  // Why Aurion
  whyAurion: {
    titulo: 'Zergatik AURION?',
    subtitulo: 'Industria-soluzio energetikoen merkatuan bereizten gaituzten arrazoiak',
    razon1: {
      titulo: '360º soluzio integrala',
      descripcion: 'Solaskide bakarra ingeniaritza, legala eta finantzaketarako'
    },
    razon2: {
      titulo: 'Hasierako inbertsiorik gabe',
      descripcion: 'CAPEX-aren oztopoa ezabatzen duten OPEX eta PPA ereduak'
    },
    razon3: {
      titulo: 'Prezio finko bermatua',
      descripcion: 'Energia-kostuen egonkortasuna epe luzera'
    },
    razon4: {
      titulo: 'Industria-esperientzia',
      descripcion: 'Eskala handiko eta konplexutasuneko proiektuetan espezialistak'
    },
    razon5: {
      titulo: 'ESG konpromisoa',
      descripcion: 'Jasangarritasun korporatiboko helburuekin lerrokatzea'
    },
    razon6: {
      titulo: 'Etengabeko laguntza',
      descripcion: 'Proiektuaren bizitza erabilgarri osoan laguntza'
    }
  },

  // Key Metrics
  metrics: {
    titulo: 'Berez hitz egiten duten emaitzak',
    subtitulo: 'Gure zenbakiek gure soluzioen benetako eragina islatzen dute',
    ahorro: 'Batez besteko aurrezkia fakturan',
    co2: 'Saihestutako CO₂ tonak',
    proyectos: 'Amaitutako proiektuak',
    satisfaccion: 'Gogobetetasun-indizea'
  },

  // Trust Bar
  trust: {
    titulo: 'Gutan fidatzen dira',
    subtitulo: 'AURION-ekin beren energia-eredua eraldatu duten enpresa liderrak'
  },

  // News
  news: {
    titulo: 'Berriak eta Merkatua',
    subtitulo: 'Energia-sektorearen azken berrien jakinean egon',
    leerMas: 'Gehiago irakurri',
    verTodas: 'Berri guztiak ikusi'
  },

  // Gallery
  gallery: {
    titulo: 'Proiektuen Galeria',
    subtitulo: 'Ezagutu sektore eta soluzio energetiko desberdinetan gure proiektu nabarmenenak'
  },

  // Main Offer / Contact Form
  offer: {
    titulo: 'Aurrezki eta karbono-aztarnaren doako azterketa',
    subtitulo: 'Aurrezki, inbertsio eta CO₂ murrizketaren eszenatokiekin aurretiazko analisia ematen dugu, konpromisorik gabe.',
    queIncluye: 'Zer biltzen du zure azterketak',
    include1: 'Kontsumoen baseline-a',
    include2: 'Proposatutako neurriak',
    include3: 'Aurrezkien estimazioa',
    include4: 'CO₂ murrizketa',
    include5: 'Inbertsio-tartea',
    include6: 'Laguntza aplikagarriak',
    include7: 'Gomendatutako hurrengo urratsa',
    entrega: 'Entrega 5-7 lanegunetan',
    entregaDesc: 'Zure instalaziorako gomendio zehatzekin txosten zehatza jasoko duzu',
    form: {
      provincia: 'Probintzia',
      provinciaPlaceholder: 'Zure probintzia',
      poblacion: 'Herria',
      poblacionPlaceholder: 'Zure herria',
      empresa: 'Enpresa',
      empresaPlaceholder: 'Zure enpresaren izena',
      nombre: 'Izena eta abizenak',
      nombrePlaceholder: 'Zure izen osoa',
      cargo: 'Kargua',
      cargoPlaceholder: 'Zure kargua enpresan',
      email: 'Email',
      emailPlaceholder: 'zu@enpresa.com',
      telefono: 'Telefonoa',
      telefonoPlaceholder: '+34 600 000 000',
      enviar: 'Doako azterketa eskatu',
      enviando: 'Bidaltzen...',
      exito: 'Eskaera behar bezala bidali da!',
      exitoDesc: 'Zure azterketa 5-7 lanegunetan jasoko duzu.',
      error: 'Errorea eskaera bidaltzean',
      errorDesc: 'Mesedez, saiatu berriro edo jarri gurekin harremanetan.',
      privacidad: 'Formulario hau bidaltzean gure pribatutasun-politika onartzen duzu. Ez ditugu zure datuak hirugarrenekin partekatzen.'
    }
  },

  // Footer
  footer: {
    descripcion: '360º-ko soluzio energetikoak industria eta nekazaritza-elikadurarako. Ingeniaritza, legala eta finantzaketa integratuak trantsizio energetikorako.',
    soluciones: 'Soluzioak',
    sectores: 'Sektoreak',
    empresa: 'Enpresa',
    recursos: 'Baliabideak',
    ingenieria: 'Ingeniaritza eta teknologia',
    compliance: 'Compliance eta legala',
    financiacion: 'Finantzaketa eta laguntzak',
    estudioGratuito: 'Doako azterketa',
    manufacturera: 'Manufaktura-industria',
    agroalimentaria: 'Nekazaritza-elikadura',
    casosExito: 'Arrakasta-kasuak',
    referencias: 'Erreferentziak',
    sobreAurion: 'AURION-i buruz',
    metodo: 'Gure metodoa',
    equipo: 'Taldea',
    contacto: 'Kontaktua',
    noticias: 'Berriak eta merkatua',
    faqs: 'FAQak',
    documentacion: 'Dokumentazioa',
    blog: 'Bloga',
    derechos: 'Eskubide guztiak erreserbatuta.',
    privacidad: 'Pribatutasun-politika',
    terminos: 'Erabilera-baldintzak',
    cookies: 'Cookieak',
    siguenos: 'Jarraitu:'
  },

  // Legal Pages
  legal: {
    privacidad: {
      titulo: 'Pribatutasun-politika',
      contenido: 'Orri honek AURION ENERGY S.L.-ren pribatutasun-politika izango du. Datu pertsonalen tratamenduari, erabiltzaileen eskubideei eta segurtasun-neurriei buruzko informazioa.'
    },
    terminos: {
      titulo: 'Erabilera-baldintzak',
      contenido: 'Orri honek AURION ENERGY S.L.-ren webgunearen erabilera-baldintza eta -baldintzak izango ditu. Erabilera-arauak, erabiltzaileen eskubideak eta betebeharrak.'
    },
    cookies: {
      titulo: 'Cookie-politika',
      contenido: 'Orri honek AURION ENERGY S.L.-ren cookie-politika izango du. Cookieen erabilerari, erabilitako cookie motei eta haiek nola kudeatu buruzko informazioa.'
    }
  }
};
